<app-alert></app-alert>
<div class="download">
  <section class="download__header">
    <div class="row download__header--welcome">
      <div class="col-sm-12 col-md-6 col-lg-7 download__header--welcome---col-left">
        <h2 [ngClass]="{ noAdminTitle: !canUpload }">{{ 'global.support-modal-page-title' | translate }}</h2>
        <p [ngClass]="{ noAdminDescription: !canUpload }">
          {{ 'global.support-modal-page-text' | translate }}
        </p>
      </div>

      <div *ngIf="!canUpload" class="col-sm-12 col-md-6 col-lg-5 download__header--welcome---col-right">
        <app-button
          type="button"
          color="warning"
          icon="agres-support"
          (btnClick)="navigateToSiteAgres()"
          title="{{ 'global.support-btn-contact-us' | translate }}">
        </app-button>
      </div>
    </div>

    <div class="panel" *ngIf="canUpload">
      <div class="panel__group">
        <div class="panel__group--buttons">
          <app-button
            type="button"
            color="info"
            icon="agres-isofarm"
            (btnClick)="openDialogProductEdit()"
            title="{{ 'download-support-page.product-management' | translate }}">
          </app-button>
          <app-button
            type="button"
            color="info"
            icon="agres-isofarm"
            (btnClick)="openCategoryManagement()"
            title="{{ 'global.support-category-management' | translate }}">
          </app-button>
          <app-button
            type="button"
            color="info"
            icon="agres-isofarm"
            (btnClick)="openFileCategoryManagement()"
            title="{{ 'global.support-file-category-management' | translate }}">
          </app-button>
          <app-button
            type="button"
            color="info"
            icon="agres-file"
            (btnClick)="openDialog()"
            title="{{ 'global.support-send-file' | translate }}">
          </app-button>
        </div>
      </div>
    </div>
  </section>

  @if (canUpload) {
    <section class="communication">
      <div class="communication__card">
        <div class="communication__card--info">
          <span class="communication__card--info---category">
            {{ 'support-campaigns.card.category' | translate }}
          </span>
          <h2 class="communication__card--info---title">
            {{ 'support-campaigns.card.title' | translate }}
          </h2>
          <p class="communication__card--info---description">
            {{ 'support-campaigns.card.description' | translate }}
            <strong>
              @if (campaignsCount === 1) {
                {{ 'support-campaigns.card.count-one' | translate: { count: campaignsCount } }}
              } @else {
                {{ 'support-campaigns.card.count-many' | translate: { count: campaignsCount } }}
              }
            </strong>
          </p>
        </div>

        <div class="communication__card--actions">
          <button type="button" class="communication__card--actions---secondary" (click)="navigateToCampaigns()">
            <i class="agres-list" aria-hidden="true"></i>
            {{ 'support-campaigns.card.view-button' | translate }}
          </button>
          <button type="button" class="communication__card--actions---primary" (click)="openCreateCampaignModal()">
            <i class="agres-plus" aria-hidden="true"></i>
            {{ 'support-campaigns.card.create-button' | translate }}
          </button>
        </div>
      </div>
    </section>
  }

  <section class="download__noFiles" *ngIf="noFiles">
    <h2>{{ 'download-support-page.no-products-yet' | translate }}</h2>
  </section>

  <!-- fixed category -->
  <section>
    <div class="download__content">
      <div class="row download__content--row">
        <div class="category-header">
          <div class="category-controls">
            <h2>Assistência Técnica</h2>
          </div>
        </div>
        @if (isPortuguese) {
          <div class="col-sm-6 col-md-4 col-lg-2 download__content--row---card-product"
            (click)="openDialogSupportTechnical()">
            <img src="./../../../../assets/images/support-page/icon-suporte-tecnico.png" alt="support assistence icon" />
            <p>Procedimentos</p>
          </div>
        }
        <div class="col-sm-6 col-md-4 col-lg-2 download__content--row---card-product"
          (click)="openDialogInformativos()">
          <img src="./../../../../assets/images/support-page/icons/clipboard-text-cinza.svg" alt="informativos icon"
            class="icon-informativos" />
          <p>{{ 'global.support-card-informativos' | translate }}</p>
        </div>
      </div>
    </div>
  </section>

  <ng-template #dialogTemplateSupportTechnical>
    <div class="download__content--close">
      <i mat-dialog-close class="i-close-modal agres-close"></i>
    </div>
    <div class="download__table---header">
      <h2 class="download__table---header----technical-assistance-title">ASSISTÊNCIA TÉCNICA</h2>
      <p class="download__table---header----technical-assistance-description">
        Precisa localizar o número de série do seu equipamento ou enviar um produto para manutenção? Clique em um dos
        botões abaixo e descubra como é simples e rápido usar os serviços de assistência técnica da Tecomec!
      </p>
    </div>
    <mat-dialog-content class="scrollable-content">
      <section class="download__table">
        <div class="download__table---title">
          <h3>PROCEDIMENTOS</h3>
        </div>

        <div class="row download__table---content">
          <div class="row download__table---content___support-technical">
            <div class="col-6">
              <p>
                <strong>Como encontrar o número de série do seu equipamento?</strong>
              </p>
              <button (click)="navigateToSiteAgresSerialNumber()"
                class="download__table---content___support-technical____button">
                <i>
                  <img src="./../../../../assets/images/support-page/icons/clipboard-text-cinza.svg"
                    alt="icon description button" />
                </i>
                Número de série
              </button>
            </div>
            <div class="col-6">
              <p>
                <strong>Como enviar seu equipamento para manutenção?</strong>
              </p>
              <button (click)="navigateToSiteAgresSendMaintenance()"
                class="download__table---content___support-technical____button">
                <i>
                  <img src="./../../../../assets/images/support-page/icons/clipboard-text-cinza.svg"
                    alt="icon description button" />
                </i>
                Manutenção de equipamentos
              </button>
            </div>
          </div>
        </div>
      </section>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button class="btn-close-modal" mat-button mat-dialog-close>
        {{ 'global.support-modal-btn-close' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>

  <ng-template #dialogTemplateInformativos>
    <div class="download__content--close">
      <i mat-dialog-close class="i-close-modal agres-close"></i>
    </div>
    <div class="download__table---header">
      <h2 class="download__table---header----technical-assistance-title">
        {{ 'global.support-informativos-modal-title' | translate }}
      </h2>
      <p class="download__table---header----technical-assistance-description">
        {{ 'global.support-informativos-modal-description' | translate }}
      </p>
    </div>
    <mat-dialog-content class="scrollable-content">
      <section class="download__table">
        @if (getUniqueFiles(getFilesByCategory(informativosCategoryKey)).length === 0) {
          <p>{{ 'download-support-page.no-products-yet' | translate }}</p>
        }

        <div *ngFor="let file of getUniqueFiles(getFilesByCategory(informativosCategoryKey)); let i = index">
          <div class="row download__table---content">
            <span><strong>{{ file.fileName }}</strong></span>

            <div class="col-sm-12 col-md-10 col-lg-4 download__table---content___data">
              <i class="agres-calendar"></i> <span>{{ file.date | date: 'dd-MM-yyyy' }}</span>
              <i class="agres-file"></i><span> .{{ getFilesGroupExtension(file) }}</span>
            </div>

            <div class="col-sm-12 col-md-10 col-lg-4 download__table---content___select">
              <mat-form-field
                appearance="outline"
                class="custom-mat-form-field flag-count-{{
                  selectedLanguageGroups[informativosCategoryKey][i]?.fileLanguages.length || 1
                }}">
                <mat-select [(ngModel)]="selectedLanguageGroups[informativosCategoryKey][i]"
                  (selectionChange)="onFileSelected(informativosCategoryKey)">
                  <mat-select-trigger>
                    <span *ngFor="let lang of selectedLanguageGroups[informativosCategoryKey][i]?.fileLanguages">
                      <img
                        [src]="getFlagUrl(lang)"
                        width="17"
                        class="flag-icon"
                        alt="{{ getLanguageName(lang) }}" />
                    </span>

                  </mat-select-trigger>

                  <mat-option *ngFor="let fileGroup of file.files" [value]="fileGroup">
                    <span *ngFor="let lang of fileGroup.fileLanguages; let last = last">
                      <img
                        [src]="getFlagUrl(lang)"
                        width="17"
                        class="flag-icon"
                        alt="{{ getLanguageName(lang) }}" />
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-sm-12 col-md-10 col-lg-4 download__table---content___button">
              <div *ngIf="!isMobile && !isTablet" class="tooltip-container">
                <div class="info-icon">i</div>
                <div class="tooltip-text">
                  {{ getDescriptionForPageLanguage(file) }}
                </div>
              </div>

              <button
                *ngIf="isMobile || isTablet"
                type="button"
                class="download__table---content___button---description"
                (click)="openDialogDescription(file)">
                <i>
                  <img
                    src="./../../../../assets/images/support-page/icons/clipboard-text-cinza.svg"
                    alt="icon description" />
                </i>
                {{ 'global.support-description' | translate }}
              </button>

              <button class="download__table---content___button---download"
                [disabled]="downloadingFiles[selectedLanguageGroups[informativosCategoryKey][i]?.filePathBlobStorage]"
                (click)="downloadFile(file, selectedLanguageGroups[informativosCategoryKey][i])">
                @if (downloadingFiles[selectedLanguageGroups[informativosCategoryKey][i]?.filePathBlobStorage]) {
                  <span class="download-spinner"></span>
                  {{ 'download-support-page.btn-downloading-file' | translate }}
                } @else {
                  <i>
                    <img src="./../../../../assets/images/support-page/icons/download-simple-blue.svg"
                      alt="icon download" />
                  </i>
                  {{ 'download-support-page.btn-download-file' | translate }}
                }
              </button>

              <button *ngIf="canUpload" type="button" class="download__table---content___button---description"
                (click)="openEditFileDialog(informativosCategoryKey, file)">
                <i class="agres-edit"></i>
                {{ 'global.edit' | translate }}
              </button>

              <button *ngIf="canUpload" type="button" class="download__table---content___button---delete"
                (click)="openModalToDeleteFile(file, selectedLanguageGroups[informativosCategoryKey][i], informativosCategoryKey)">
                <i>
                  <img src="./../../../../assets/images/support-page/icons/icon-trash-white.svg" alt="icon delete" />
                </i>
                {{ 'global.delete' | translate }}
              </button>
            </div>
          </div>
        </div>
      </section>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button class="btn-close-modal" mat-button mat-dialog-close>
        {{ 'global.support-modal-btn-close' | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>

  <!-- end fixed category-->

  <!-- Loop to create category -->
  <section *ngFor="let categoria of categorizedProductList; let i = index"
    [hidden]="!categoria.value || categoria.value.length === 0">
    <div id="desktop" class="download__content">
      <div class="row download__content--row">
        <h2 *ngIf="!canUpload">{{ categoria.label }}</h2>
        <div *ngIf="canUpload" class="category-header">
          <div class="category-controls">
            <h2>{{ categoria.label }}</h2>
            <button (click)="moveCategoryUp(i)" [disabled]="i === 0">↑</button>
            <button (click)="moveCategoryDown(i)" [disabled]="i === categorizedProductList.length - 1">↓</button>
          </div>
        </div>
        <div class="col-sm-6 col-md-4 col-lg-2 download__content--row---card-product"
          *ngFor="let item of categoria.value" (click)="openDialogProductData(item)"
          [ngClass]="{ 'download--active-product': selectedProduct === item.productName }">
          <img *ngIf="item.imageUrl" [src]="item.imageUrl" alt="product image" />
          <p>{{ item.productName }}</p>
        </div>
      </div>
    </div>
    <!-- End loop to create category -->

    <!-- MOBILE loop to create category -->
    <div id="mobile">
      <h2 class="category-product-name">{{ categoria.label }}</h2>
      <div class="carousel-container">
        <div class="carousel">
          <div class="carousel-item" *ngFor="let item of categoria.value" (click)="openDialogProductData(item)"
            [ngClass]="{ 'download--active-product': selectedProduct === item.productName }">
            <img *ngIf="item.imageUrl" [src]="item.imageUrl" alt="product image" />
            <p>{{ item.productName }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- end loop to create category -->
  <!--END MOBILE Loop to create category -->

  <ng-template #dialogTemplateProductData let-data>
    <div class="download__content--close">
      <i mat-dialog-close class="i-close-modal agres-close"></i>
    </div>
    <div class="download__table---header">
      <div class="row">
        <div class="col-sm-12 col-lg-3 download__table---header__productImg">
          <img [src]="data.item.imageUrl" alt="imagem do produto" />
        </div>
        <div class="col-sm-12 col-lg-9 download__table---header__product-description">
          <h2>{{ data.item.productName }}</h2>
          <p>{{ 'global.support-product-message-default' | translate }}</p>
        </div>
      </div>
    </div>

    <mat-dialog-content class="scrollable-content">
      <div *ngFor="let category of categoriesWithFiles" class="download__table">
        <div class="download__table---title">
          <h3>{{ getCategoryName(category) | uppercase }}</h3>
        </div>

        <div *ngFor="let file of getUniqueFiles(getFilesByCategory(category)); let i = index">
          <div class="row download__table---content">
            <span><strong>{{ file.fileName }}</strong></span>

            <div class="col-sm-12 col-md-10 col-lg-4 download__table---content___data">
              <i class="agres-calendar"></i> <span>{{ file.date | date: 'dd-MM-yyyy' }}</span>
              <i class="agres-share"></i> <span>{{ file.version }}</span> <i class="agres-file"></i
              ><span> .{{ getFilesGroupExtension(file) }}</span>
            </div>

            <div class="col-sm-12 col-md-10 col-lg-4 download__table---content___select">
              <mat-form-field
                appearance="outline"
                class="custom-mat-form-field flag-count-{{
                  selectedLanguageGroups[category][i]?.fileLanguages.length || 1
                }}">
                <mat-select [(ngModel)]="selectedLanguageGroups[category][i]"
                  (selectionChange)="onFileSelected(category)">
                  <mat-select-trigger>
                    <span *ngFor="let lang of selectedLanguageGroups[category][i]?.fileLanguages">
                      <img
                        [src]="getFlagUrl(lang)"
                        width="17"
                        class="flag-icon"
                        alt="{{ getLanguageName(lang) }}" />
                    </span>
       
                  </mat-select-trigger>

                  <mat-option *ngFor="let fileGroup of file.files" [value]="fileGroup">
                    <span *ngFor="let lang of fileGroup.fileLanguages; let last = last">
                      <img
                        [src]="getFlagUrl(lang)"
                        width="17"
                        class="flag-icon"
                        alt="{{ getLanguageName(lang) }}" />
                    </span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-sm-12 col-md-10 col-lg-4 download__table---content___button">
              <div *ngIf="!isMobile && !isTablet" class="tooltip-container">
                <div class="info-icon">i</div>
                <div class="tooltip-text">
                  {{ getDescriptionForPageLanguage(file) }}
                </div>
              </div>

              <button
                *ngIf="isMobile || isTablet"
                type="button"
                class="download__table---content___button---description"
                (click)="openDialogDescription(file)">
                <i>
                  <img
                    src="./../../../../assets/images/support-page/icons/clipboard-text-cinza.svg"
                    alt="icon description" />
                </i>
                {{ 'global.support-description' | translate }}
              </button>

              <button class="download__table---content___button---download"
                [disabled]="downloadingFiles[selectedLanguageGroups[category][i]?.filePathBlobStorage]"
                (click)="downloadFile(file, selectedLanguageGroups[category][i])">
                @if (downloadingFiles[selectedLanguageGroups[category][i]?.filePathBlobStorage]) {
                  <span class="download-spinner"></span>
                  {{ 'download-support-page.btn-downloading-file' | translate }}
                } @else {
                  <i>
                    <img src="./../../../../assets/images/support-page/icons/download-simple-blue.svg"
                      alt="icon download" />
                  </i>
                  {{ 'download-support-page.btn-download-file' | translate }}
                }
              </button>

              <button *ngIf="canUpload" type="button" class="download__table---content___button---description"
                (click)="openEditFileDialog(category, file)">
                <i class="agres-edit"></i>
                {{ 'global.edit' | translate }}
              </button>

              <button *ngIf="canUpload" type="button" class="download__table---content___button---delete"
                (click)="openModalToDeleteFile(file, selectedLanguageGroups[category][i], category)">
                <i>
                  <img src="./../../../../assets/images/support-page/icons/icon-trash-white.svg" alt="icon delete" />
                </i>
                {{ 'global.delete' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button class="btn-close-modal" mat-button mat-dialog-close>
        {{ 'global.support-modal-btn-close' | translate }}
      </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #dialogTemplateDescription let-data>
  <h2 mat-dialog-title>{{ 'global.support-description' | translate }}</h2>
  <mat-dialog-content class="scrollable-content">
    <p class="modal-description-paragraph">{{ data?.description }}</p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button class="btn-close-modal" mat-button mat-dialog-close>
      {{ 'global.support-modal-btn-close' | translate }}
    </button>
  </mat-dialog-actions>
</ng-template>



</div>

<app-confirmar-modal *ngIf="showConfirmationModal" [(modal)]="showConfirmationModal"
  [mensagem]="confirmationModalMessage" [tipo]="confirmationModalType" [titulo]="modalTitleConfirmation"
  [confirmButtonText]="modalTranslateButtonConfirmText" [cancelButtonText]="modalTranslateButtonCancelText"
  (modalChange)="showConfirmationModal = $event" (buttonAction)="onButtonAction($event)">
</app-confirmar-modal>